module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('b-card', [_c('h5', [_vm._v("Left drawer displayed as a Reponsive Sidebar. "), _c('span', {
    staticClass: "font-italic"
  }, [_vm._v("Resize the window to test")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', {
    staticClass: "text-right"
  }, [_c('h5', [_vm._v("Right drawer hidden on page load.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-card', [_c('h5', [_vm._v("Customize button styles")]), _vm._v(" "), _c('p', [_vm._v("Use a style object e.g.")]), _vm._v(" "), _c('pre', [_c('code', [_vm._v("\n     {\n        background: 'rgba(150, 5, 0, 0.2)',\n        padding: '0 5px',\n        marginTop: '56px',\n        marginRight: '15px',\n        height: '100%',\n        top: '0'\n      }\n    ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cb3c81e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/Hello.vue
// module id = 847
// module chunks = 1